<template>
  <Header />
  <Splash />
  <div class="about">
    <div id="glass">
      <div class="row">
      <div id="yellowcircle"></div>
        <div id="redcircle"></div>
        <div id="bluecircle"></div>
      </div>
    </div>
    <h1>jajaj acá seguimos trabajando vuelva pronto 🛠️</h1>
  </div>
  <Footer />
  <Copyright />

</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Splash from "@/components/Splash.vue";
import Footer from "@/components/Footer.vue";
import Copyright from "@/components/Copyright.vue";

export default {
  name: "Home",
  components: {
    Header,
    Splash,
    Footer,
    Copyright,
  }
};
</script>

<style>

#about{
  align-content: center;
}
#yellowcircle{
  position: relative;
    height: 250px;
    width: 250px;
    background-color: #FFF200;
    border-radius: 150px;
    filter: blur(85px);
    margin: -25px;
}
#redcircle{
  position: relative;
    height: 100px;
    width: 100px;
    background-color: #ed145b;
    border-radius: 150px;
    filter: blur(85px);
    margin: 70px;
}
#bluecircle{
  position: relative;
    height: 340px;
    width: 340px;
    background-color: #1b1464;
    border-radius: 150px;
    filter: blur(85px);
    margin: 10px;
}

#glass{
  margin: auto;
  padding: 10px;
  width: 800px;
  height: 449px;
  border: black solid 1px;
  background: rgb(143,148,251);
background: linear-gradient(150deg, rgba(143,148,251,1) 0%, rgba(78,84,200,1) 100%);
mix-blend-mode: multiply;

}
</style>